export default {
    // récuperer toutes les entites dans la base de données 
    get_logactivity(serverParams){
        return axios.get('/logactivity',{
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    // get_logactivity(serverParams){
    //     return axios.post('/logactivity?page=' + serverParams.page, serverParams, {
    //         headers: {
    //             Authorization: "Bearer " + token
    //         }
    //     }) 
    // },
    get_balance_entites(tokens) {
        return axios.get('/authentite', {
            headers: {
                Authorization: "Bearer " + tokens
            }
        })
    },
    get_all_authentites(serverParams){
        return axios.get('/authentite?page=' + serverParams.page, {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    get_all_typesentite(){
        return axios.get('/typesentite', {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    // récuperer toutes les entites dans la base de données 
    post_logactivity(serverParams){
        return axios.post('/logactivity?page=' + serverParams.page, serverParams, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    put_entites(id,entite){
        
        return axios.put('/entites/'+id,entite, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    show_entites(id){
        return axios.get('/entites/'+id, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    delete_entites(id){
        return axios.delete('/entites/'+id, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },

}